(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
  import('@troop-themes/main').then(({ Cart }) => {
    document.querySelectorAll('.image-with-text-overlay--root[data-section-id]').forEach((section) => {
      if (section.hasAttribute('data-add-to-cart-bound')) {
        return;
      }

      section.setAttribute('data-add-to-cart-bound', 'true');

      section.addEventListener('submit', async (event) => {
        const form = event.target;
        const button = event.submitter || form.querySelector('button[type="submit"]');

        if (!button || !button.classList.contains('button-add-to-cart')) {
          return;
        }

        event.preventDefault();
        button.disabled = true;

        try {
          const formData = new FormData(form);
          const request = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: `${new URLSearchParams(formData).toString()}&sections=${Cart.sections.join(',')}`
          };

          await Cart.addItems(request, button);
        } catch (error) {
          console.error('Custom image with text overlay add to cart failed:', error);
        } finally {
          button.disabled = false;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
  import('@troop-themes/main').then(({ Cart }) => {
    document.querySelectorAll('slideshow-carousel[data-section-id]').forEach((slideshow) => {
      if (slideshow.hasAttribute('data-add-to-cart-bound')) {
        return;
      }

      slideshow.setAttribute('data-add-to-cart-bound', 'true');

      slideshow.addEventListener('submit', async (event) => {
        const form = event.target;
        const button = event.submitter || form.querySelector('button[type="submit"]');

        if (!button || !button.classList.contains('button-add-to-cart')) {
          return;
        }

        event.preventDefault();
        button.disabled = true;

        try {
          const formData = new FormData(form);
          const request = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: `${new URLSearchParams(formData).toString()}&sections=${Cart.sections.join(',')}`
          };

          await Cart.addItems(request, button);
        } catch (error) {
          console.error('Custom slideshow add to cart failed:', error);
        } finally {
          button.disabled = false;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
